<script setup lang="ts">
/** Welcome Letter — SG Incorporation (Post) */
import { ref } from 'vue';
import CddVarField from '../incorporation-pre/cdd/CddVarField.vue';
import './allotDoc.css';

let seq = 1;
const contacts = ref<number[]>([1]);
function add() { contacts.value.push(++seq); }
function del(id: number) { if (contacts.value.length > 1) contacts.value = contacts.value.filter((x) => x !== id); }
</script>

<template>
  <div class="allot-doc">
    <!-- Word header: CSP letterhead (phone / email / website 수동 입력) -->
    <div class="sg-csp-letterhead">
      <div><CddVarField field-key="csp_name" label="CSP Name" /></div>
      <div><CddVarField field-key="csp_address_line1" label="CSP Address Line 1" /></div>
      <div><CddVarField field-key="csp_address_line2" label="CSP Address Line 2" /></div>
      <div class="sg-csp-meta">
        <span>Phone: <CddVarField field-key="csp_phone" label="CSP Phone" /></span>
        <span>E-mail: <CddVarField field-key="csp_email" label="CSP Email" /></span>
        <span>Website: <CddVarField field-key="csp_website" label="CSP Website" /></span>
      </div>
    </div>

    <div class="doc-head">
      <div class="doc-lbl-title" style="text-align:center; font-size:16px">WELCOME LETTER</div>
    </div>

    <p class="doc-p">
      To: <CddVarField field-key="company_name" label="Company Name" /><br />
      Date: <CddVarField field-key="letter_date" label="Letter Date" />
    </p>

    <p class="doc-p">Dear Sir/Madam,</p>
    <p class="doc-p">
      We are pleased to welcome you as our client. We are providing you the following pointers for ease of
      facilitating our working relationship and to ensure that your presence in Singapore is compliant with
      the relevant regulations.
    </p>

    <p class="doc-sec-title" style="text-align:left">1. EMAILS AND CONTACT DETAILS</p>
    <p class="doc-p">
      Unless otherwise instructed, our primary point of contact with you will be via email. All important
      reminders, letters, and other relevant information will be sent to the official email address provided
      by your company. Kindly therefore indicate your official contact details below. Any future changes
      should be promptly communicated to us in writing.
    </p>

    <table class="cdd-tbl">
      <thead>
        <tr><th>Name</th><th>Contact No.</th><th>Email Address</th><th style="width:36px" /></tr>
      </thead>
      <tbody>
        <tr v-for="(id, i) in contacts" :key="id">
          <td><CddVarField :field-key="`c_${id}_name`" :label="`Contact ${i + 1} Name`" /></td>
          <td><CddVarField :field-key="`c_${id}_contact_no`" :label="`Contact ${i + 1} No.`" /></td>
          <td><CddVarField :field-key="`c_${id}_email`" :label="`Contact ${i + 1} Email`" /></td>
          <td><button type="button" class="cdd-rowbtn" :disabled="contacts.length <= 1" @click="del(id)">×</button></td>
        </tr>
        <tr><td colspan="4"><button type="button" class="cdd-addrow" @click="add">+ Add contact</button></td></tr>
      </tbody>
    </table>

    <p class="doc-sec-title" style="text-align:left">2. CHANGES TO OTHER COMPANY PARTICULARS</p>
    <p class="doc-p">
      Kindly inform us of any impending or affected changes in the company such as, but not limited to,
      mailing address, registered office address and bank account details and we will need to promptly update
      your secretarial records and advise the relevant authorities accordingly.
    </p>

    <p class="doc-sec-title" style="text-align:left">3. INSTRUCTIONS</p>
    <p class="doc-p">
      Please ensure that you provide us with instructions in writing, through letters, email, or fax, to
      prevent any future issue or dispute. We also recommend that you give us a call to confirm our receipt
      of your instructions.
    </p>

    <p class="doc-p" style="margin-top:18px">Yours faithfully,</p>

    <table class="cdd-tbl" style="margin-top:14px">
      <thead>
        <tr><th>Acknowledged By — For <CddVarField field-key="csp_name" label="CSP Name" /></th>
            <th>For <CddVarField field-key="company_name" label="Company Name" /></th></tr>
      </thead>
      <tbody>
        <tr>
          <td>
            Name: <CddVarField field-key="csp_signatory_name" label="CSP Signatory" /><br />
            Designation: <CddVarField field-key="csp_signatory_title" label="CSP Title" /><br />
            Date: <CddVarField field-key="letter_date" label="Letter Date" />
          </td>
          <td>
            Name: <CddVarField field-key="company_signatory_name" label="Company Signatory" /><br />
            Designation: <CddVarField field-key="company_signatory_title" label="Company Title" /><br />
            Date: <CddVarField field-key="acknowledgement_date" label="Acknowledgement Date" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
